import {FC} from "react";
import {TeamSpaceItem} from "../../../../lib/src/api/repositories/documentation-library-repository";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import {ModalFooter} from "../../../../lib/src/components/layout/ModalProvider";
import {useToasts} from "../../../../lib/src/toasts/toasts";

export const DeleteFolderModal: FC<{ item: TeamSpaceItem, onFinished: () => void }> = ({ item, onFinished }) => {
  const { documentations } = useApiCall(config)
  const {showToast} = useToasts()

  const save = async () => {
    await documentations.deleteFolder(item.teamSpaceId, item.id)
      .catch(() => {
        showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
      })
    onFinished()
  }

  return <div className={'flex flex-col space-y-4'}>
    <div className={'bg-brand-secondary-container border border-brand-200 rounded-lg px-3 py-2'}>
      <div>Let op! Alle items die onder deze folder vallen komen door het verwijderen een laag naar boven</div>
    </div>
    <div>Weet je zeker dat je de folder <span className={'font-bold'}>{item.name}</span> wilt verwijderen?</div>
    <ModalFooter text={'Verwijderen'} onSubmit={async () => {
      await save()
      close()
    }} />
  </div>
}